import './App.css';
import './assets/Fonts/fonts.css';
import { useEffect } from 'react';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Home from './Components/Home';
import useWindowWidth from './hooks/useWindowWidth';

function App() {
  const windowWidth = useWindowWidth();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const isCollapsed = windowWidth < 1280;
    localStorage.setItem('navbarCollapsed', JSON.stringify(isCollapsed));
  }, [windowWidth]);

  useEffect(() => {
    // Set the page title
    document.title = 'Silzila';

    // Dynamically set the favicon
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = '/logo.png';
    link.type = 'image/png';
    document.head.appendChild(link);

    // Cleanup function (optional)
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="App" data-testid="app-wrapper">
      <Home />
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </DndProvider>
  );
}

export default App;
